import { Component } from '@angular/core';
import {
  FormBuilder,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-first-login-change-password',
  templateUrl: './first-login-change-password.component.html',
  styleUrls: ['./first-login-change-password.component.css'],
})
export class FirstLoginChangePasswordComponent {
  loading = false;
  errorMessage = '';

  successMessage = '';

  client: string = '';

  form = this.fb.group(
    {
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required],
    },
    {
      validators: this.passwordMatchValidator,
    },
  );

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private messageService: MessageService,
  ) {}





  ngOnInit(): void {
    this.initClient();
  }

  private initClient(): void {
    const urlSegment = this.router.url.split('/')?.[1];
    this.client = urlSegment || 'default';
  }

  passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const newPassword = control.get('newPassword')?.value;
    const confirmPassword = control.get('confirmPassword')?.value;

    if (!newPassword || !confirmPassword) return null;

    return newPassword === confirmPassword ? null : { passwordMismatch: true };
  }



  onSubmit() {
    this.errorMessage = '';
    this.successMessage = '';

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;

    const payload = {
      oldPassword: this.form.value.oldPassword!,
      newPassword: this.form.value.newPassword!,
    };

    // récupérer le type de compte
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    this.authService.changePassword(payload, this.client).subscribe({
      next: () => {
        this.loading = false;

        //this.authService.setMustChangePassword(false);

        //this.authService.logout();

        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail:
            'Mot de passe modifié avec succès. Vous serez redirigé vers la page de connexion pour vous reconnecter.',
          life: 3000,
        });

        setTimeout(() => {
          const signinRoute =
            this.client === 'company' ? '/company/signin' : '/merchant/signin';
          this.router.navigate([signinRoute]).then((success) => {
           // console.log('Navigation vers signin réussie ?', success);
          });
        }, 1000);
      },
      error: (err) => {
        this.loading = false;

        if (err?.error?.errors && Array.isArray(err.error.errors)) {
          this.errorMessage = err.error.errors.map((e: any) => e.msg).join(', ');
        } else {
          this.errorMessage = err?.error?.message;
        }

        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: this.errorMessage,
          life: 3000,
        });
      },
      /*error: (err) => {
        this.loading = false;

        console.log(err);
        this.errorMessage =
          err?.status == 400
            ? 'Ancien mot de passe incorrect.'
            : 'Impossible de modifier le mot de passe. Veuillez contacter le support';

        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: this.errorMessage,
          life: 3000,
        });
      },*/
    });
  }
}
